import { Button, Form } from "antd";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FieldDate from "../fields/FieldDate";
import FieldSelect from "../fields/FieldSelect";
import {
  schemaFormExtraction,
  SchemaFormExtraction,
} from "../../../features/forms/schemas/schemaFormExtraction";
import styles from "./FormExtraction.module.scss";

const FORMAT_OPTIONS = [
  { value: "csv", label: "CSV" },
  { value: "pdf", label: "PDF" },
];

const LABEL_COL = { span: 8 };
const WRAPPER_COL = { span: 16 };

type Props = {
  onSubmit: SubmitHandler<SchemaFormExtraction>;
  isLoading: boolean;
};

const FormExtraction: React.FC<Props> = ({ onSubmit, isLoading }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SchemaFormExtraction>({
    resolver: zodResolver(schemaFormExtraction),
    defaultValues: {
      format: "csv",
    },
  });

  return (
    <Form
      className={styles.form}
      labelAlign="left"
      colon={false}
      onFinish={handleSubmit(onSubmit)}
      id="form-extraction"
    >
      <FieldDate
        name="dateFrom"
        label="Date de dÃ©but"
        control={control}
        errorMessage={errors.dateFrom?.message}
        labelCol={LABEL_COL}
        wrapperCol={WRAPPER_COL}
      />
      <FieldDate
        name="dateTo"
        label="Date de fin"
        control={control}
        errorMessage={errors.dateTo?.message}
        labelCol={LABEL_COL}
        wrapperCol={WRAPPER_COL}
      />
      <FieldSelect
        name="format"
        label="Format"
        placeholder="SÃ©lectionnez un format"
        control={control}
        options={FORMAT_OPTIONS}
        errorMessage={errors.format?.message}
        labelCol={LABEL_COL}
        wrapperCol={WRAPPER_COL}
      />
      <div className={styles.actions}>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          TÃ©lÃ©charger
        </Button>
      </div>
    </Form>
  );
};

export default FormExtraction;
